import { Carousel } from '@mantine/carousel';
import '@mantine/carousel/styles.css';
import { AspectRatio, Box, Card, Title, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

const data = [
	{
		title: 'Ohana Vibe',
		url: 'https://youtu.be/CD42Yg-f0Xw?si=5bQVWInKKGYyU-mF'
	},
	{
		title: 'A day at the carnival',
		url: 'https://www.youtube.com/watch?v=KumPPDLKwkM&pp=0gcJCd4JAYcqIYzv'
	},
	{
		title: 'June Bug',
		url: 'https://youtu.be/HozuWZRYno4?si=qM614WEYn2TGwnwz'
	},
	{
		title: 'Green Grass',
		url: 'https://youtu.be/S3zJ7mwCz6k?si=s4heg13sqzRVmoMl'
	},
];

function getYouTubeId(url: string): string | null {
	const regExp = /(?:youtube\.com\/.*v=|youtu\.be\/)([^&?/]+)/;
	const match = url.match(regExp);
	return match ? match[1] : null;
}

type carouselProps = {
	title: string,
	url: string
};

const CarouselCard: React.FC<carouselProps> = ({ title, url }) => {
	const theme = useMantineTheme();
	const videoId = getYouTubeId(url);
	const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

	return (
		<Card
			shadow="md"
			radius="md"
			padding="lg"
			bg={theme.colors.blue[0]}
			h={isMobile ? "300px" : "500px"}
			withBorder
			style={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'flex-start'
			}}>
			<Card.Section>
				<AspectRatio ratio={16 / 9}>
					<iframe
						src={videoId ? `https://www.youtube.com/embed/${videoId}` : undefined}
						title={title}
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowFullScreen
						style={{
							width: '100%',
							height: '100%',
							border: 0
						}}
					/>
				</AspectRatio>
			</Card.Section>
			<Title order={4} mt="md" mb="xs">{title}</Title>
		</Card>
	);
}

const VideoCarousel: React.FC = () => {
	const theme = useMantineTheme();
	const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

	const slides = data.map((item) => (
		<Carousel.Slide key={item.title}>
			<CarouselCard {...item} />
		</Carousel.Slide>
	));

	return (
		<Box style={{ maxWidth: 800, margin: '0 auto', width: '100%' }}>
			<Carousel
				slideSize={{ base: '100%', sm: '100%' }}
				slideGap="md"
				height={isMobile ? 400 : 550}
				withIndicators
			>
				{slides}
			</Carousel>
		</Box>
	);
}

export default VideoCarousel;